import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Paper,
  TextField,
  Backdrop,
  InputAdornment,
  CircularProgress,
  IconButton
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import moment from 'moment';
import syncFill from '@iconify/icons-eva/sync-fill';
import UpdateIcon from '@material-ui/icons/Update';
import { makeStyles } from '@material-ui/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import {
  baseUrl,
  gender,
  maritalState,
  employers,
  titles,
  employerCodes,
  countries,
  occupations,
  sectors,
  memberTypes,
  memberStatuses,
  terminationReasons,
  tierSchemes,
  relationShips
} from '../../utils/constants';
import { useClientContext } from '../../context/client_context';
import { useConstantsContext } from '../../context/constants_context';
import Controls from '../controls/Controls';
import DependantSub from './DependantSub';

// import ProductCost from './ProductCost';
// import ProductCostList from './ProductCostList';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function ClientFull() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { towns, suburbs, banks, bankBranches } = useConstantsContext();
  const { currentClient, setCurrentClient, setDependant } = useClientContext();
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [expanded, setExpanded] = React.useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [isMain, setMain] = useState(true);
  const [newMember, setNew] = useState(true);
  const [operation, setOperation] = useState('save');
  const [loading, setLoading] = useState(false);
  const [branchList, setBranchList] = useState([
    {
      refId: 0,
      name: 'No Bank Selected'
    }
  ]);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  const PersonalDetailsSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, 'First Name is too Short!')
      .max(50, 'First Name is too Long!')
      .required('First name required'),
    surname: Yup.string()
      .min(2, 'surname is too Short!')
      .max(50, 'surname is too Long!')
      .required('surname is required'),
    memberShipNo: Yup.string().required('Member Fund # is required'),
    suffix: Yup.string().required('Suffix # is required'),
    group_id: Yup.number().required('Employer grouping is required')
  });

  const formik = useFormik({
    initialValues: currentClient,
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      console.log('custingo before that exe 2', values);
      if (operation === 'save') {
        saveClientData(values);
      } else if (operation === 'terminate') {
        terminateMember(values);
        console.log('am terminating client');
      } else if (operation === 'reinstate') {
        reinstateMember(values);
      }
    }
  });

  useEffect(() => {
    if (currentClient.cif_number) {
      setNew(false);
      if (currentClient.suffix !== '01') setMain(false);
    }
  }, []);

  currentClient.dateOfBirth = moment(currentClient.dateOfBirth).format('yyyy-MM-DD');
  // setMemberNo(currentClient.memberShipNo);
  currentClient.membershipStartDate = moment(currentClient.membershipStartDate).format(
    'yyyy-MM-DD'
  );
  if (currentClient.termdate)
    currentClient.termdate = moment(currentClient.termdate).format('yyyy-MM-DD');
  const date1 = moment(currentClient.dateOfBirth);
  const date2 = moment();
  const diff = date2.diff(date1, 'years');
  currentClient.age = diff;
  console.log('currentClient', currentClient);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const saveClientData = (client) => {
    setDisabled(true);
    setLoading(true);
    if (newMember) {
      client.age = 0;
      client.dependants = 0;
      client.acceptedBy = sessionStorage.getItem('oldRefId');
    }
    const jsonClient = [];
    jsonClient.push(client);
    console.log('client stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/saveClient`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned client result', result);
          setLoading(false);
          setCurrentClient(result);
          // setDependant(result);
          notifyPopup(`Client Saved Successfully!`, 'success');
        },
        (error) => {
          notifyPopup(`Error in Saving Client!: ${error}`, 'error');
        }
      );
  };

  const terminateMember = (value) => {
    if (sessionStorage.getItem('oldRefId') !== '167') {
      notifyPopup(`Only Supervisor Can Terminate Member...Member not terminated!`, 'error');
      formik.setFieldValue('termdate', '');
      formik.setFieldValue('reasonForTerm', '');
      return;
    }
    setLoading(true);
    fetch(
      `${baseUrl}/api/client/terminateMember?cif_no=${value.cif_number}&termination_date=${
        value.termdate
      }&terminated_by=${sessionStorage.getItem('oldRefId')}&dependants=${value.dependents}&reason=${
        value.reasonForTerm
      }&Scheme=${value.principalSchemeID}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('from reinstate', result);
          if (result.result.replyStatus === 0) {
            notifyPopup(`Member Terminated Successfully!`, 'success');
            navigate('/dashboard', { replace: true });
          } else {
            notifyPopup(`Error in Terminating Client!: ${result.result.replyMessage}`, 'error');
          }
        },
        (error) => {
          notifyPopup(`Error in Terminating Client..!: ${error}`, 'error');
        }
      );
  };

  const reinstateMember = (value) => {
    setLoading(true);
    const reinstateDate = moment();
    fetch(
      `${baseUrl}/api/client/ReinstateMember?cif_no=${value.cif_number}&reinstation_date=${moment(
        reinstateDate
      ).format('YYYY-MM-DD')}&terminated_by=${sessionStorage.getItem('oldRefId')}&dependants=${
        value.dependents
      }&group_id=${value.group_id}&anniv_date=${moment(reinstateDate).format(
        'YYYY-MM-DD'
      )}&schemeID=${value.principalSchemeID}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('from reinstate', result);
          if (result.result.replyStatus === 0) {
            notifyPopup(`Member Reinstated Successfully!`, 'success');
            navigate('/dashboard', { replace: true });
          } else {
            notifyPopup(`Error in Reinstating Client!: ${result.result.replyMessage}`, 'error');
          }
        },
        (error) => {
          notifyPopup(`Error in Reinstating Client..!: ${error}`, 'error');
        }
      );
  };

  const handleSchemeSubmit = async (e) => {
    if (newMember) {
      formik.setFieldValue('principalSchemeID', e.target.value);
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      return;
    }
    console.log('came here to submit');
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    console.log('Scheme of eeeeeeeee', e.target.value);
    if (e.target.value === 0) {
      notifyPopup(`Scheme was not changed!`, 'error');
      return;
    }
    setLoading(true);
    await axios
      .post(
        `${baseUrl}/api/client/UpdateMemberScheme?cif_no=${currentClient.cif_number}&newScheme=${e.target.value}`
      )
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Changing Scheme!: ${result.replyMessage}`, 'error');
          } else {
            console.log('returned doc', result);
            formik.setFieldValue('principalSchemeID', e.target.value);
            navigate('/dashboard', { replace: true });
          }
        },
        (error) => {
          notifyPopup(`Error in Changing Scheme..Client Scheme not Changed!: ${error}`, 'error');
        }
      );
  };

  const handleGroupChange = async (e) => {
    if (newMember) {
      formik.setFieldValue('group_id', e.target.value);

      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    if (e.target.value === 0) {
      notifyPopup(`group_id was not changed!`, 'error');
      return;
    }

    setLoading(true);
    const user = sessionStorage.getItem('oldRefId');
    await axios
      .post(
        `${baseUrl}/api/client/UpdateMemberGroup?cif_no=${currentClient.cif_number}&oldGroup=${currentClient.group_id}&newGroup=${e.target.value}
        &user=${user}&newMemberNo=${formik.values.memberShipNo} `
      )
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Changing Scheme!: ${result.replyMessage}`, 'error');
          } else {
            console.log('returned doc', result);
            formik.setFieldValue('group_id', e.target.value);
            navigate('/dashboard', { replace: true });
          }
        },
        (error) => {
          notifyPopup(`Error in Changing Scheme..Client Scheme not Changed!: ${error}`, 'error');
        }
      );
  };

  const handleMemberNumberChange = async (e) => {
    console.log('e from number', e);
    console.log('e from values', formik.values.memberShipNo);
    console.log('e from cif_number', formik.values.cif_number);
    console.log('e from memberShipNo', currentClient.memberShipNo);

    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });

    if (currentClient.memberShipNo === formik.values.memberShipNo) {
      notifyPopup(`Ooops, you forgot to change the Membership #!`, 'error');
      return;
    }

    if (currentClient.cif_number !== formik.values.parent_Cif) {
      notifyPopup(`Not Allowed to change Membership # from a Dependant profile!`, 'error');
      return;
    }

    setLoading(true);
    const user = sessionStorage.getItem('oldRefId');
    await axios
      .post(
        `${baseUrl}/api/client/UpdateMemberNumber?cif_no=${currentClient.cif_number}&oldNumber=${currentClient.memberShipNo}&newNumber=${formik.values.memberShipNo}
        &user=${user} `
      )
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Membership #!: ${result.replyMessage}`, 'error');
          } else {
            console.log('returned change', result);
            navigate('/dashboard', { replace: true });
          }
        },
        (error) => {
          notifyPopup(`Error in Changing Member #..Client Number not Changed!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const closePopup = () => {
    setOpenPopup(false);
    navigate('/dashboard', { replace: true });
  };

  const { errors, touched, getFieldProps } = formik;

  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
              onClick={handleLoadingClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Typography variant="subtitle1">Member Maintenance...</Typography>
            <Typography variant="subtitle1" color="error">
              {isMain && 'Main Member'}
              {isMain === false && 'Dependant'}
            </Typography>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              {!currentClient.cif_number && (
                <Grid item xs={12} sm={3}>
                  <Controls.Input name="memberShipNo" label="Member #" />
                </Grid>
              )}
              {currentClient.cif_number > 0 && (
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    type="text"
                    size="small"
                    value={formik.values.memberShipNo}
                    {...getFieldProps('memberShipNo')}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            onClick={(e) =>
                              setConfirmDialog({
                                isOpen: true,
                                title: 'Are you sure you want to Change Membership Number',
                                subTitle: 'All Dependants will be changed also',
                                heading: 'Change Membership #',
                                color: 'primary',
                                onConfirm: () => {
                                  handleMemberNumberChange(e);
                                }
                              })
                            }
                          >
                            <Icon icon={syncFill} />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    error={Boolean(touched.memberShipNo && errors.memberShipNo)}
                    helperText={touched.memberShipNo && errors.memberShipNo}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={3}>
                <Controls.SelectJson
                  name="group_id"
                  label="Group"
                  options={employerCodes}
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="group_idlabel">Group</InputLabel>
                  <Select
                    id="group_id"
                    value={formik.values.group_id}
                    name="group_id"
                    fullWidth
                    size="small"
                    variant="outlined"
                    disabled={!isMain}
                    onChange={(e) =>
                      setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure you want to Change Member Group',
                        subTitle: 'Always Change Member # before Group!!!!',
                        heading: 'Change Member Group',
                        color: 'primary',
                        onConfirm: () => {
                          handleGroupChange(e);
                        }
                      })
                    }
                  >
                    {employers.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Divider
                style={{ background: '#1a237e', height: 2, margin: 2, width: '90%', paddingTop: 4 }}
                variant="middle"
              />
              <Grid item xs={12} sm={2}>
                <Controls.SelectJson name="title_id" label="Title" options={titles} />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="firstName" label="First Name" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="surname" label="Last Name" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="idNumber" label="Id Number" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.DateTime name="dateOfBirth" label="Date Of Birth" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.SelectJson name="sex_ID" label="Gender" options={gender} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="age" label="Age" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.SelectJson
                  name="relationship_ID"
                  label="Relationship to Main"
                  options={relationShips}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="suffix" label="Suffix" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Controls.Input name="dpt" label="Dept" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Controls.Input name="stn" label="Stn" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="station" label="Station" />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="dist" label="District" />
              </Grid>
              {isMain && (
                <Grid item xs={12} sm={4} paddingBottom={2}>
                  <Controls.Input name="dependents" label="# of Dependants" />
                </Grid>
              )}
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.SelectJson
                  name="maritalStatus"
                  label="Marital Status"
                  options={maritalState}
                />
              </Grid>

              <Divider
                style={{ background: '#1a237e', height: 2, margin: 2, width: '90%', paddingTop: 4 }}
                variant="middle"
              />
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel id="tierLabel">Tier Scheme</InputLabel>
                  <Select
                    id="principalSchemeID"
                    value={formik.values.principalSchemeID}
                    name="principalSchemeID"
                    fullWidth
                    size="small"
                    variant="outlined"
                    disabled={!isMain}
                    onChange={(e) =>
                      setConfirmDialog({
                        isOpen: true,
                        title: 'Are you sure you want to Update Member Scheme',
                        subTitle: 'To Undo you have to change again',
                        heading: 'Change Member Scheme',
                        color: 'primary',
                        onConfirm: () => {
                          handleSchemeSubmit(e);
                        }
                      })
                    }
                  >
                    {tierSchemes.map((item) => (
                      <MenuItem key={item.refId} value={item.refId}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.SelectJson
                  name="memberType_ID"
                  label="Member Type"
                  options={memberTypes}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.SelectJson
                  name="memberStatus"
                  label="Member Status"
                  options={memberStatuses}
                />
              </Grid>
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.DateTime name="membershipStartDate" label="Membership Start Date" />
              </Grid>

              {/* <Grid item xs={12} sm={2} paddingBottom={2}>
                <Controls.SelectJson name="industry_ID" label="Industry" options={sectors} />
              </Grid>
              <Grid item xs={12} sm={2} paddingBottom={2}>
                <Controls.SelectJson
                  name="occupation_ID"
                  label="Occupation"
                  options={occupations}
                />
              </Grid> */}
              <Grid item xs={12} sm={4} paddingBottom={2}>
                <Controls.SelectJson name="country_ID" label="Country" options={countries} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.CheckBox name="cash_paying" label="Pays Cash" />
              </Grid>
            </Grid>
            <div className={classes.root}>
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Contact and Address</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2} marginTop={2}>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined" margin={10}>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="physical_Add1" label="Physical Address" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="suburbLabel">Suburb</InputLabel>
                            <Select
                              id="physical_Suburb_ID"
                              value={formik.values.physical_Suburb_ID}
                              name="physical_Suburb_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('physical_Suburb_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {suburbs.map((item) => (
                                <MenuItem key={item.suburb_Id} value={item.suburb_Id}>
                                  {item.suburb_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="townLabel">Town</InputLabel>
                            <Select
                              id="physical_Town_ID"
                              value={formik.values.physical_Town_ID}
                              name="physical_Town_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('physical_Town_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {towns.map((item) => (
                                <MenuItem key={item.town_Id} value={item.town_Id}>
                                  {item.town_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="home_Phone" label="Home Phone" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="work_Phone" label="Work Phone" />
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Paper variant="outlined">
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="postal_Add1" label="Postal Address" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="psuburbLabel">Postal Suburb</InputLabel>
                            <Select
                              id="postal_Suburb_ID"
                              value={formik.values.postal_Suburb_ID}
                              name="postal_Suburb_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('postal_Suburb_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {suburbs.map((item) => (
                                <MenuItem key={item.suburb_Id} value={item.suburb_Id}>
                                  {item.suburb_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <FormControl fullWidth>
                            <InputLabel id="townLabel">Postal Town</InputLabel>
                            <Select
                              id="postal_Town_ID"
                              value={formik.values.postal_Town_ID}
                              name="postal_Town_ID"
                              fullWidth
                              size="small"
                              variant="outlined"
                              onChange={(e) => {
                                formik.setFieldValue('postal_Town_ID', e.target.value);
                              }}
                            >
                              <MenuItem key="" value="0">
                                Not Selected
                              </MenuItem>
                              {towns.map((item) => (
                                <MenuItem key={item.town_Id} value={item.town_Id}>
                                  {item.town_Name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="postal_Phone" label="Postal Phone" />
                        </Grid>
                        <Grid item xs={12} sm={12} margin={2}>
                          <Controls.Input name="emailAddress" label="Email Address" />
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Dependants</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>Scheme:</Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} disabled>
                      <Controls.Input name="parent_Cif" label="Main Member Code" />
                    </Grid>
                    {currentClient.parent_Cif > 0 && currentClient.suffix === '01' && (
                      <Grid item xs={12} sm={2}>
                        <Button
                          variant="outlined"
                          type="button"
                          startIcon={<FiberNewIcon />}
                          onClick={() => setOpenPopup(true)}
                        >
                          Add Dependant
                        </Button>
                      </Grid>
                    )}
                    <Typography paddingTop={1} paddingLeft={2}>
                      Add Dependant's Only Shows When Main Member...
                    </Typography>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Banking Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={12} sm={12}>
                      <Paper elevation={3} marginLeft={1}> */}
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="bank_IDLabel">Bank</InputLabel>
                        <Select
                          id="bank_ID"
                          value={formik.values.bank_ID}
                          name="bank_ID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('bank_ID', e.target.value);
                            setBranchList(
                              bankBranches.filter((m) => m.bankRefId === e.target.value)
                            );
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {banks.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="branchIDLabel">Bank Branch</InputLabel>
                        <Select
                          id="branch_ID"
                          value={formik.values.branch_ID}
                          name="branch_ID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('branch_ID', e.target.value);
                            formik.setFieldValue('bankBranchRefId', e.target.value);
                            const tempCurr = branchList.filter(
                              (item) => item.refId === e.target.value
                            );
                            formik.setFieldValue('sortCode', tempCurr[0].branchCode);
                            console.log('e.target.value', e.target.value);
                            console.log('tempCurr', tempCurr[0].branchCode);
                            console.log('branchList', branchList);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {branchList.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="sortCode" label="Sort Code" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="acc_No" label="Account #" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="accName" label="AccountName" />
                    </Grid>
                    {/* </Paper>
                    </Grid> */}
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Next Of Kin</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="nextOfKinFName" label="First Name" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="nextOfKinSName" label="Surname #" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="nextOfKinHomePhone" label="Home Phone" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="nextOfKinWorkPhone" label="Work Phone" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="nextOfKinAdd1" label="Address" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="townLabel">Next of Kin Town</InputLabel>
                        <Select
                          id="nextOfKinTown_ID"
                          value={formik.values.nextOfKinTown_ID}
                          name="nextOfKinTown_ID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('nextOfKinTown_ID', e.target.value);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {towns.map((item) => (
                            <MenuItem key={item.town_Id} value={item.town_Id}>
                              {item.town_Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="suburbnLabel">Next Of Kin Suburb</InputLabel>
                        <Select
                          id="nextOfKin_Suburb_ID"
                          value={formik.values.nextOfKin_Suburb_ID}
                          name="nextOfKin_Suburb_ID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('nextOfKin_Suburb_ID', e.target.value);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {suburbs.map((item) => (
                            <MenuItem key={item.suburb_Id} value={item.suburb_Id}>
                              {item.suburb_Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Termination Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <Controls.DateTime name="termdate" label="Terminated Date" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        name="reasonForTerm"
                        id="reasonForTerm"
                        select
                        fullWidth
                        size="small"
                        label="Reason for Termination"
                        value={formik.values.reasonForTerm}
                        onChange={(e) => {
                          formik.setFieldValue('reasonForTerm', e.target.value);
                        }}
                      >
                        <MenuItem key="" value="0">
                          Not Selected
                        </MenuItem>
                        {terminationReasons.map((option) => (
                          <MenuItem key={option.refId} value={option.name}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Controls.Input name="terminatedBy" label="Approved by" disabled />
                    </Grid>
                    {currentClient.memberStatus === 1 && (
                      <Grid item xs={12} sm={1}>
                        <Button
                          type="submit"
                          variant="outlined"
                          color="error"
                          startIcon={<ThumbDownIcon />}
                          onClick={() => setOperation('terminate')}
                        >
                          Terminate
                        </Button>
                      </Grid>
                    )}
                    {currentClient.memberStatus === 5 && (
                      <Grid item xs={12} sm={1}>
                        <Button
                          type="submit"
                          variant="outlined"
                          color="success"
                          startIcon={<ThumbUpIcon />}
                          onClick={() => setOperation('reinstate')}
                        >
                          Reinstate
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
            <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
              <Grid item xs={12} sm={1} marginRight={1}>
                <Button
                  type="submit"
                  variant="outlined"
                  disabled={isDisabled}
                  startIcon={<ThumbUpIcon />}
                  onClick={() => setOperation('save')}
                >
                  Save...
                </Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
        <Controls.Notification notify={notify} setNotify={setNotify} />
        <Controls.Popup title="Add Dependant" openPopup={openPopup} setOpenPopup={setOpenPopup}>
          <DependantSub closePopup={closePopup} />
        </Controls.Popup>
        <Controls.ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      </CardContent>
    </Card>
  );
}
